import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '../lib/api';
import { Button } from './ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { ArrowLeft, MailCheck } from 'lucide-react';

const EsqueciSenha = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [enviado, setEnviado] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, {
        email: email.trim(),
        origin: window.location.origin,
      });
      setEnviado(true);
    } catch {
      // Resposta é sempre genérica; mostramos sucesso de qualquer forma.
      setEnviado(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 to-stone-100 dark:from-stone-950 dark:to-stone-900 flex items-center justify-center p-4 transition-colors duration-300">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img
            src="/logo.png"
            alt="Logo Identidade Gente"
            className="h-16 w-auto mx-auto object-contain"
            style={{ maxWidth: '200px' }}
          />
          <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mt-4">Recuperar Senha</h1>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Esqueci minha senha</CardTitle>
            <CardDescription>
              Informe seu e-mail e enviaremos um link seguro para você redefinir a senha.
            </CardDescription>
          </CardHeader>
          <CardContent>
            {enviado ? (
              <div className="text-center py-4" data-testid="forgot-success">
                <MailCheck className="h-12 w-12 text-primary mx-auto mb-3" />
                <p className="text-gray-700 dark:text-gray-200 font-medium">
                  Se o e-mail estiver cadastrado, você receberá um link de recuperação em instantes.
                </p>
                <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">
                  O link é válido por 1 hora. Verifique também a caixa de spam.
                </p>
                <Button
                  type="button"
                  variant="outline"
                  className="w-full mt-6"
                  onClick={() => navigate('/login')}
                  data-testid="back-to-login-btn"
                >
                  <ArrowLeft className="mr-2 h-4 w-4" />
                  Voltar para o login
                </Button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4" data-testid="forgot-form">
                <div>
                  <Label htmlFor="email">E-mail</Label>
                  <Input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="seu@email.com"
                    required
                    data-testid="forgot-email-input"
                  />
                </div>
                <Button type="submit" className="w-full" disabled={loading} data-testid="forgot-submit-btn">
                  {loading ? 'Enviando...' : 'Enviar link de recuperação'}
                </Button>
                <Button
                  type="button"
                  variant="ghost"
                  className="w-full"
                  onClick={() => navigate('/login')}
                  data-testid="forgot-back-btn"
                >
                  <ArrowLeft className="mr-2 h-4 w-4" />
                  Voltar para o login
                </Button>
              </form>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default EsqueciSenha;
